import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormikInput, FormikRadio, FormikSelectSimple } from './FieldTypes';
import Asterisk from '@atoms/Asterisk';
import { P, FormLabel, Label } from '@styled';

const FormColumn = styled.div`
    width: 100%;
    @media (min-width: 768px) {
        width: 50%;
    }
`;

export const DonationFund = () => (
    <fieldset>
        <legend className="mb-0" htmlFor="foundationFundID">
            Foundation
            <Asterisk />
        </legend>

        <p className="small">
            (Your donation will support our general fund unless you specify otherwise from the options below)
        </p>

        <FormikSelectSimple name="foundationFund" id="foundationFundID">
            <option value="GEN" label="General Fund">
                General Fund
            </option>
            <option value="GENCND">General Fund – Canada</option>
            <option value="CBS">CenterBuild Conference Scholarship Fund</option>
            <option value="DLIPP">David Lipp Scholarship Fund</option>
            <option value="DIV">Diversity Fund</option>
            <option value="EJAN">Eric J. Almquist NEXUS Scholarship Fund</option>
            <option value="FLS">Florida Conference &amp; Deal Making Scholarship Fund</option>
            <option value="NGN">Next Generation Fund</option>
            <option value="NGNCND">Next Generation Fund - Canada</option>
            <option value="RECONFB">RECon Foundation Benefactor</option>
            <option value="RECONFBC">RECon Foundation Benefactor - Canada</option>
        </FormikSelectSimple>
    </fieldset>
);

export const Tribute = ({ isTribute, onIsTributeChange }) => (
    <fieldset>
        <legend>Tribute</legend>
        <P>Would you like to make this gift in honor or in memory of someone?</P>

        <FormikRadio
            name="tribute"
            type="radio"
            id="tributeYes"
            value="yes"
            label="Yes"
            checked={isTribute}
            onChange={onIsTributeChange}
        />

        <FormikRadio
            name="tribute"
            type="radio"
            id="tributeNo"
            value="no"
            label="No"
            checked={!isTribute}
            onChange={onIsTributeChange}
        />
    </fieldset>
);

Tribute.propTypes = {
    isTribute: PropTypes.bool.isRequired,
    onIsTributeChange: PropTypes.func.isRequired,
};

export const CartMemberInfo = () => (
    <FormColumn className="align-top d-inline-block">
        <fieldset className="mt-0">
            <legend>Card Details</legend>
            <FormikInput name="nameOnCard" id="nameOnCardID" type="text" label="Name on Card" />
            <FormikInput name="cardNumber" id="cardNumberID" type="text" label="Card Number" />
            <Label className="mb-3 mb-md-2">
                <FormLabel>
                    Expiration Date
                    <Asterisk />
                </FormLabel>
                <select name="expirationDateMonth" id="expirationDateMonthID" className="mr-2">
                    <option value="01">January</option>
                    <option value="02">February </option>
                    <option value="03">March</option>
                    <option value="04">April</option>
                    <option value="05">May</option>
                    <option value="06">June</option>
                    <option value="07">July</option>
                    <option value="08">August</option>
                    <option value="09">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                </select>
                <select name="expirationDateYear" id="expirationDateYearID">
                    <option value="20"> 2020</option>
                    <option value="21"> 2021</option>
                    <option value="22"> 2022</option>
                    <option value="23"> 2023</option>
                    <option value="24"> 2024</option>
                    <option value="25"> 2025</option>
                </select>
            </Label>
        </fieldset>
    </FormColumn>
);
